import { graphql } from "@/graphql/codegen"

export const BatchDeleteProductsFromEquivalencyGroupDocument = graphql(`
  mutation BatchDeleteProductsFromEquivalencyGroup($input: BatchDeleteProductsFromEquivalencyGroupInput!) {
    equivalencyGroup {
      batchDeleteProductsFromEquivalencyGroup(input: $input) {
        ... on BatchDeleteProductsFromEquivalencyGroupSuccess {
          success
        }
        ... on EquivalencyGroupFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
